import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";
import {
  getPortalToken,
  portalCompanyRequests,
} from "@/modules/tramites/materialidad/clientPortalApi";
import PortalMaterialidadShell from "./PortalMaterialidadShell";

export default function PortalMaterialidadCompanyRequestsPage() {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!getPortalToken()) {
      navigate("/portal-materialidad/login", { replace: true });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await portalCompanyRequests(clientId);
        if (!cancelled) setItems(data?.items || []);
      } catch (err) {
        if (!cancelled) {
          toast.error(err?.response?.data?.detail || "No se pudieron cargar las solicitudes.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [clientId, navigate]);

  return (
    <PortalMaterialidadShell>
      <div className="space-y-4" data-testid="portal-materialidad-company-requests">
        <Link
          to="/portal-materialidad/empresas"
          className="inline-flex items-center gap-1 text-xs text-[#0F2D5C] no-underline"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Mis empresas
        </Link>
        <h1 className="text-2xl font-semibold text-[#0F2D5C]">Solicitudes</h1>
        {loading ? (
          <p className="text-sm text-slate-500 flex items-center gap-2">
            <Loader2 className="w-4 h-4 animate-spin" /> Cargando…
          </p>
        ) : items.length === 0 ? (
          <p className="text-sm text-slate-500">No hay solicitudes para esta empresa.</p>
        ) : (
          <ul className="space-y-2">
            {items.map((r) => (
              <li key={r.id}>
                <Link
                  to={`/portal-materialidad/solicitudes/${encodeURIComponent(r.id)}`}
                  className="block rounded-sm border border-slate-200 bg-white px-4 py-3 no-underline hover:border-[#0F2D5C]/40"
                  data-testid={`portal-request-${r.id}`}
                >
                  <p className="text-sm font-semibold text-slate-900">{r.title}</p>
                  <p className="text-xs text-slate-500">
                    {r.status} · pendientes {r.pending_items}/{r.total_items}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </PortalMaterialidadShell>
  );
}
